import React from 'react';
import { FaUserCircle, FaPhoneAlt, FaCaretRight } from 'react-icons/fa';
import { moeda } from '../../components/funcoes';
import * as S from './styles';
import theme from '../../theme';
import { format, parseISO } from 'date-fns';
import { useImprimirPedido } from './useImprimirPedido';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { Spacer } from '../../components/Spacer';
import { ItemPedido } from './ItemPedido';
import { Separator } from '../../components/Separator';
import { deliveryTypes } from '../../enums/deliveryTypes';

export default function ImprimirPedido(props) {
  const { loading, itensPedido, pedido, orderChange, imprimir } =
    useImprimirPedido(props);

  if (loading) {
    return (
      <div>
        <S.ContentLoading>
          <Spacer y={40} />

          <LoadingSpinner />

          <Spacer y={10} />

          <span>Loading...</span>
        </S.ContentLoading>
      </div>
    );
  }

  if (!pedido?.Codigo) return null;

  return (
    <div>
      <S.Content>
        <S.Title>PEDIDO #{pedido.Codigo}</S.Title>

        <S.LineSeparator />

        <S.SectionTitle>DADOS</S.SectionTitle>
        <S.Description>
          {!!pedido?.DataPedido &&
            format(parseISO(pedido.DataPedido), 'dd-MM-yyyy')}{' '}
          {pedido.Hora}
        </S.Description>
        {pedido.IdUser !== '0' && pedido.IdUser !== null && (
          <S.Description>
            <FaUserCircle />
            <Spacer x={10} />
            {pedido.Nome}
          </S.Description>
        )}
        {pedido.IdUser !== '0' && pedido.IdUser !== null && (
          <S.Description>
            <FaPhoneAlt />
            <Spacer x={10} />
            {pedido.Telefone}
          </S.Description>
        )}
        {pedido.IdUser === '0' ||
          (pedido.IdUser === null && (
            <S.Description>
              <FaUserCircle />
              <Spacer x={10} />
              {pedido.NomeSemCadastro}
            </S.Description>
          ))}
        {pedido.IdUser === '0' ||
          (pedido.IdUser === null && (
            <S.Description>
              <FaPhoneAlt />
              <Spacer x={10} />
              {pedido.CelularSemCadastro}
            </S.Description>
          ))}

        <S.LineSeparator />
        {pedido.TipoEntrega && (
          <S.DescriptionBold>
            <FaCaretRight />
            <Spacer x={10} />
            {deliveryTypes?.find((x) => x.value === pedido.TipoEntrega)?.label}
            {['AG', 'AGRE'].includes(pedido.TipoEntrega)
              ? ` em ${format(
                  new Date(pedido.DataAgendamento),
                  'dd/MM/yyyy HH:mm',
                )}`
              : ''}
          </S.DescriptionBold>
        )}

        <Spacer y={10} />

        <S.LineSeparator />

        <S.SectionTitle>PRODUTO(S)</S.SectionTitle>

        {itensPedido?.map((product, index) => (
          <>
            {index > 0 && <Separator />}
            <ItemPedido key={product.descricao} product={product} />
          </>
        ))}

        <Spacer y={20} />

        <S.LineSeparator />

        <S.ViewFooterTotal>
          <S.ItemFooterPagamento>
            Pagamento:
            <div>{pedido.FormaPagamento ?? 'Online'}</div>
          </S.ItemFooterPagamento>
          {!!parseFloat(pedido.Troco) && (
            <>
              <S.ItemFooterPagamento>
                <div>Troco para: </div>
                <b>{moeda(pedido.Troco)}</b>
              </S.ItemFooterPagamento>
            </>
          )}
          <S.ItemFooterPagamento>
            <div>Pedido:</div>
            <b>{moeda(pedido.ValorTotal)}</b>
          </S.ItemFooterPagamento>
          {pedido.Desconto > 0 && (
            <S.ItemFooterPagamento>
              <div>Desconto:</div>
              <b>{moeda(pedido.Desconto)}</b>
            </S.ItemFooterPagamento>
          )}
          {pedido.TaxaEntrega > 0 && (
            <S.ItemFooterPagamento>
              <div>Taxa Entrega:</div>
              <b>{moeda(pedido.TaxaEntrega)}</b>
            </S.ItemFooterPagamento>
          )}
          {pedido.TaxaAdministracao > 0 && (
            <S.ItemFooterPagamento>
              <div>Taxa de Administracao:</div>
              <b>{moeda(pedido.TaxaAdministracao)}</b>
            </S.ItemFooterPagamento>
          )}

          <div
            style={{ border: `1px solid ${theme.cores.linha}`, width: '100%' }}
          />

          <S.ItemFooterPagamento>
            <b>Total:</b>
            <b>
              {moeda(
                parseFloat(pedido.ValorTotal) + parseFloat(pedido.TaxaEntrega) + parseFloat(pedido.TaxaAdministracao) - parseFloat(pedido.Desconto),
              )}
            </b>
          </S.ItemFooterPagamento>
          {+orderChange > 0 && <S.ItemFooterPagamento>
            <div>Troco do cliente:</div>
            <b>{moeda(orderChange)}</b>
          </S.ItemFooterPagamento>}
        </S.ViewFooterTotal>

        <S.LineSeparator />

        {['EN', 'AG'].includes(pedido.TipoEntrega) && (
          <div>
            <S.SectionTitle>Entrega</S.SectionTitle>
            {pedido.IdEndereco !== null && (
              <div className="card-body">
                <S.Cep>
                  <b>Cep:</b>{pedido.Cep}
                </S.Cep>
                <div className="card-text">
                  <S.Description>
                    <b>Endereço:</b> {pedido.Logradouro} 
                  </S.Description>
                  <S.Description>
                    <b>Bairro:</b> {pedido.nomeBairro} 
                  </S.Description>
                  <S.Description>
                    <b>Nº:</b> {pedido.Numero} 
                  </S.Description>
                  <S.Description>
                    <b>Complemento:</b>{pedido.Complemento} {pedido.PontoRef}
                  </S.Description>
                  <S.Description>
                    {pedido.Cidade} - {pedido.Uf}
                  </S.Description>
                </div>
              </div>
            )}
            {pedido.IdEndereco === null && (
              <div className="card-text">
                <S.Description>
                  {pedido.EnderecoSemCadastro}, {pedido.nomeBairroSemCadastro}
                </S.Description>
                <S.Description>
                  {pedido.cidadeSemCadastro} - {pedido.estadoSemCadastro}
                </S.Description>
              </div>
            )}
          </div>
        )}
        {pedido.TipoEntrega === 'RE' && (
          <S.Description>
            <b>RETIRAR NO LOCAL</b>
          </S.Description>
        )}
        {pedido.TipoEntrega === 'LOCAL' && (
          <S.Description>
            <b>CONSUMIR NO LOCAL</b>
          </S.Description>
        )}
      </S.Content>
      <S.SubmitButton
        id="buttonPrint"
        title="Imprimir"
        onClick={() => imprimir()}
      >
        Imprimir
      </S.SubmitButton>
    </div>
  );
}
